import React from "react"
import moment from "moment"
import { CustomServerSideReactTable } from "components/utility"
import { withBreadcrumb, useBread } from "components/breadcrumb"

import { announcementTypes, findTypeValueByKey } from "utils/types"
import {
  GET_ANNOUNCEMENT_LIST,
  DELETE_ANNOUNCEMENT,
  GET_TABLE_FIELDS,
  SUM_ANNOUNCEMENT_LIST
} from "../../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const AnnouncementList = (props) => {
  useBread({ to: props.match.url, name: "公告清單" }, true)

  const fieldsDefinitions = () => {
    return [
      {
        id: "startTime",
        Header: "起始時間",
        style: columStyle,
        accessor: (data) => moment(data?.startTime).format("YYYY-MM-DD a h:mm"),
        width: 100
      },
      {
        id: "title",
        Header: "公告名稱",
        style: columStyle,
        accessor: "title"
      },
      {
        id: "content",
        Header: "公告內容",
        style: columStyle,
        accessor: "content"
      },
      {
        id: "type",
        Header: "類型",
        style: columStyle,
        accessor: (data) => findTypeValueByKey(announcementTypes, data.type),
        width: 80
      },
      {
        id: "isNotificationAssistant",
        Header: "通知業務",
        style: columStyle,
        accessor: "isNotificationAssistant",
        width: 100,
        Cell: (cell) => (
          <div>{cell.row.isNotificationAssistant === true ? "是" : "否"}</div>
        )
      },
      {
        id: "creator",
        Header: "發送者",
        style: columStyle,
        width: 120,
        accessor: (data) => data?.creator?.name
      }
    ]
  }

  return (
    <CustomServerSideReactTable
      queryObjectGql={GET_ANNOUNCEMENT_LIST}
      sumTotalQueryObjectGql={SUM_ANNOUNCEMENT_LIST}
      deleteObjectGql={DELETE_ANNOUNCEMENT}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectName="公告"
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasSettingButton={false}
      hasEditButton={true}
      hasDeleteButton={true}
      fieldsDef={fieldsDefinitions()}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(AnnouncementList)
